import ArticleInsight from "../pages/articleInsight/ArticleInsight";
import Demographics from "../pages/demographics/Demographics";
import Digital from "../pages/digital/Digital";
import Overview from "../pages/overview/Overview";
import Print from "../pages/print/Print";
import PublishedNewsMedia from "../pages/publishedNewsMedia/PublishedNewsMedia";
import Radio from "../pages/radio/Radio";
import TV from "../pages/tv/TV";

const navRoutes = [
  {
    path: "overview",
    component: Overview,
  },
  {
    path: "content",
    component: PublishedNewsMedia,
  },
  {
    path: "demographics",
    component: Demographics,
  },
  {
    path: "digital",
    component: Digital,
  },
  {
    path: "print",
    component: Print,
  },
  {
    path: "radio",
    component: Radio,
  },
  {
    path: "tv",
    component: TV,
  },
  {
    path: "content/article-insight",
    component: ArticleInsight,
  },
];

export default navRoutes;
